import React, { useState } from 'react';
import Form from './FormComponents/Form';
import Row from 'components/Grid/Row';
import Column from 'components/Grid/Column';
import { useDavidApi } from 'utility/DavidApi/DavidApi';
import Button from 'components/Button/Button';
import LoadingOverlay from 'components/Layout/MapView/LoadingOverlay/LoadingOverlay';
import { SubmitButton, YellowButtonWrapper } from 'components/Button/Button.styles';

function DeleteProjectForm({
    id, 
    hideModal,
    onDelete,
    ...otherProps
}) {
    const api = useDavidApi();
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);

    const submitHandler = () => {
        (async () => {
            setLoading(true);
            await api.deleteProject(id);
            
            setTimeout(() => {
                hideModal();

                if (onDelete) {
                    onDelete();
                }

                setLoading(false);
            }, 
                1500
            );
            
        })();
    }

    return (
        <Form 
            successMessage='Project Deleted!'
            id={id} 
            asyncSubmitHandler={submitHandler}
            errors={errors}
            setErrors={setErrors}
            {...otherProps}
        >
        {loading && (
            <LoadingOverlay isLighter>
                <h2>
                    Project deleted! Refreshing...
                </h2>
            </LoadingOverlay>
        )}
            <p>Are you sure you want to delete project number <strong>{id}</strong>?</p>
            <Row gutter={25} style={{width:'75%', marginTop:'30px'}}>
                <Column width={1/2}>
                    <YellowButtonWrapper>
                        <SubmitButton>
                            Yes, Delete
                        </SubmitButton>
                    </YellowButtonWrapper>
                </Column>
                <Column width={1/2}>
                    <Button onClick={hideModal}>
                        No, Don't Delete
                    </Button>
                </Column>
            </Row>
        </Form>
    )
  }

export default DeleteProjectForm;
